import { render, staticRenderFns } from "./ReportAI.vue?vue&type=template&id=197f2440&scoped=true&"
import script from "./ReportAI.vue?vue&type=script&lang=js&"
export * from "./ReportAI.vue?vue&type=script&lang=js&"
import style0 from "./ReportAI.vue?vue&type=style&index=0&id=197f2440&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "197f2440",
  null
  
)

export default component.exports